import OBTDialog2 from './OBTDialog2';

export default OBTDialog2;